const maxZIndex = 2147483647; // 32-bit integer maximum

/**
 * Returns the next available z-index for group geometries (max + 1), clamped to 32-bit int max.
 *
 * @param groupGeometries - The array of group geometry objects.
 * @returns The next available z-index.
 */
export const getTopZIndex = (groupGeometries) =>
    Math.min(
        maxZIndex,
        groupGeometries.length > 0
            ? Math.max(...groupGeometries.map(({ zIndex }) => zIndex ?? 0)) + 1
            : 0,
    );
